import { render, staticRenderFns } from "./ComboParamPage.vue?vue&type=template&id=ec27f28e"
import script from "./ComboParamPage.vue?vue&type=script&lang=js"
export * from "./ComboParamPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports